import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-test-execution-page',
  templateUrl: './test-execution-page.component.html',
  styleUrls: ['./test-execution-page.component.css']
})
export class TestExecutionPageComponent implements OnInit {

  urlCode: string | null;

  constructor(
    private route: ActivatedRoute,
  ) {
    this.urlCode = this.route.snapshot.paramMap.get('urlCode');
  }

  ngOnInit(): void {
  }

}
